// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2QtHs","inputWrap":"CustomTip_inputWrap__3LUr8"};